export const credentials = [
  { n: '01', title: 'BSc (Hons) Medical Herbalism', sub: 'University of Westminster · 2008' },
  {
    n: '02',
    title: '500+ Hours Supervised Practice',
    sub: 'Clinical training during degree programme',
  },
  {
    n: '03',
    title: '30+ Years of Holistic Health Experience',
    sub: 'UK and Jamaica · Instrumental Health since 2004',
  },
  { n: '04', title: 'Traditional Healer Studies', sub: 'Gambia, Togo & Burkina Faso, West Africa' },
  { n: '05', title: 'Dogon Kemetic School', sub: 'Official UK Representative' },
  { n: '06', title: '15+ Years Herbal Walk Facilitation', sub: 'Across the United Kingdom' },
]

export const recognitions = [
  { label: "Unsung Women's Award", sub: 'Haringey Borough Council' },
  { label: 'I See You Documentary', sub: 'Co-creator & Co-producer' },
  { label: 'Medicine Festival', sub: 'Speaker & Educator' },
  { label: 'Dogon Kemetic School', sub: 'Official UK Representative' },
]

export const pillars = [
  {
    label: 'Traditional African & Caribbean Healing',
    desc: 'Drawing on generational plant knowledge passed down through communities and traditional healers across Jamaica, West Africa, and the diaspora.',
  },
  {
    label: 'Modern Clinical Herbalism',
    desc: 'Grounded in evidence-based phytotherapy, anatomy, physiology, and clinical practice, with rigorous training that informs every consultation.',
  },
  {
    label: "Women's Health Specialism",
    desc: 'Twenty years of specialist focus on menstrual health, hormonal balance, menopause, fertility, and reproductive wellbeing using plant medicine.',
  },
  {
    label: 'Community Education',
    desc: 'Herbal walks, public speaking, workshops, and programmes bringing healing knowledge back to the communities that need it most.',
  },
]
